// extracted by mini-css-extract-plugin
module.exports = {"percentage":"ratio-chart_percentage__2rqjd","description":"ratio-chart_description__2lvtO"};